'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidMoreVertical = function IoAndroidMoreVertical(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.3 10.6c0 1.7-1.5 3.2-3.2 3.2s-3.1-1.5-3.1-3.2 1.4-3.1 3.1-3.1 3.2 1.4 3.2 3.1z m0 18.8c0 1.7-1.5 3.1-3.2 3.1s-3.1-1.4-3.1-3.1 1.4-3.1 3.1-3.1 3.2 1.4 3.2 3.1z m0-9.4c0 1.7-1.5 3.1-3.2 3.1s-3.1-1.4-3.1-3.1 1.4-3.1 3.1-3.1 3.2 1.4 3.2 3.1z' })
        )
    );
};

exports.default = IoAndroidMoreVertical;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-more-vertical.js
// module id = 2363
// module chunks = 168707334958949